import React from "react";

import "./blog.css";
import { isMobile } from "../../../../utils/utils";
import { be } from "../../../../utils/bliss";
import Link from "../../../../components/link/link";
import Text from "../../../../components/text/text";
import Headline from "../../../../components/headline/headline";

const MODULE_NAME = "Blog";

const BlogGroup = ({ posts }) => {
  const styleObj = {
    textAlign: "left"
  };
  return (
    <div className={(be(MODULE_NAME, "containerGroup"), "col")}>
      {posts.slice(1, 3).map((item, index) => (
        <div className={be(MODULE_NAME, "wrapperGroup")} key={item.id}>
          <a href={item.link} style={{ textDecoration: "none" }}>
            <div className={be(MODULE_NAME, "photoSideGroup")}>
              <img
                className={be(MODULE_NAME, "imgLeftGroup")}
                alt="blogPhoto"
                src={item._embedded["wp:featuredmedia"][0].media_details.sizes.medium_large.source_url}
              />
            </div>
            <div className={be(MODULE_NAME, "infoGroup")}>
              <div>
                {isMobile() && (
                  <div style={{ textAlign: "left" }}>
                    <Text small bold greenReward>
                      {item.title.rendered}
                    </Text>
                  </div>
                )}
                {!isMobile() && (
                  <div className="pb-2" style={{ display: "flex", justifyContent: "flex-start", textAlign: "left" }}>
                    <Headline subheadline bold greenReward>
                      {item.title.rendered}
                    </Headline>
                  </div>
                )}
              </div>
              {isMobile() && (
                <Text lighter greenReward>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.content.rendered.substring(0, item.content.rendered.lastIndexOf(" ", 50)) + "..."
                    }}
                    style={styleObj}
                  />
                </Text>
              )}
              {!isMobile() && (
                <Text small lighter greenReward>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.content.rendered.substring(0, item.content.rendered.lastIndexOf(" ", 205)) + "..."
                    }}
                    style={styleObj}
                  />
                </Text>
              )}
            </div>
            <div style={{ width: "65%", marginLeft: "35%" }} className={be(MODULE_NAME, "moreButtonGroup")}>
              <Link bold underline leftSide to={item.link}>
                Číst více &#8594;
              </Link>
            </div>
          </a>
        </div>
      ))}
    </div>
  );
};

export default BlogGroup;
